import $ from 'jquery'
import globalEventBus from 'toxilibs/event_bus_queued.js'
import developmentEnvironment from '../development_environment.js'



function displayErrorStats () {
    let eventBus = globalEventBus


    let screen
    eventBus.on('screen loaded', function (newScreen) {
        screen = newScreen
    })


    let way
    eventBus.on('way updated', function (newWay) {
        way = newWay
    })


    eventBus.on('world loaded', function () {
        screen.clear({layer: 9})
    })



    let currentPosition
    let errors

    eventBus.on('stats data loaded', function (data) {
        if (!errors) {
            console.log('Use o / p keys to navigate through stats')
        }
        errors = data.errors
        currentPosition = 0
        render()
    })


    $(window).on('keydown', function (event) {
        if (event.key === 'o' && currentPosition > 0) {
            currentPosition -= 1
            render()
        }

        if (event.key === 'p' && currentPosition < way.length - 1) {
            currentPosition += 1
            render()
        }
    })


    function render () {
        let {cell} = way[currentPosition]
        screen.clear({layer: 9})
        screen.drawCircle({
            layer:  9,
            center: cell,
            radius: 0.2,
            lineWidth: 0.05,
            fillColor:   'red',
            strokeColor: 'white'
        })


        if (currentPosition >= way.length - 1) {
            return
        }


        let {cell: nextCell} = way[currentPosition + 1]

        screen.drawLine({
            layer:  9,
            origin: cell,
            end:    nextCell,
            lineWidth: 0.2,
            strokeColor: 'red'
        })


        let {lastCell} = errors[currentPosition + 1]
        for (let key in lastCell) {
            let [x, y] = key.split(' ').map(k => parseInt(k, 10))
            screen.drawCircle({
                layer:  9,
                center: {x, y},
                radius: 0.2,
                fillColor: '#333'
            })
            screen.drawText({
                text:   lastCell[key],
                layer:  9,
                center: {x, y},
                fillColor: 'white'
            })
        }
    }
}



if (developmentEnvironment) {
    displayErrorStats()
}
